/* 
import LayoutComp from './Components/LayoutComp';
import Login from './Pages/Auth/Login';
import './App.css'
import { useState, useEffect } from 'react';

function App() {
  const [isLoggedIn, setAuth] = useState(localStorage.getItem("auth"));

  useEffect(() => {
    setAuth(localStorage.getItem("auth") == null ? false : localStorage.getItem("auth"));
  }, []);


  return (
    <>


      {!isLoggedIn !=="false" ? <Login /> : <LayoutComp />}


    </>
  )
}

export default App;
 */
import LayoutComp from './Components/LayoutComp';
import Login from './Pages/Auth/Login';
import './App.css';
import { useState, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoadingPage from './Pages/LoadingPage';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("auth") === "true");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = localStorage.getItem("auth");
    setIsLoggedIn(auth === "true");
    setLoading(false);
  }, []);

  if (loading) {
    return <LoadingPage />; // Utiliser la page de chargement animée
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isLoggedIn
            ? <Navigate to="/dashboard" replace />
            : <Login onLogin={() => setIsLoggedIn(true)} />
        }
      />
      <Route
        path="/*"
        element={
          isLoggedIn
            ? <LayoutComp onLogout={() => setIsLoggedIn(false)} />
            : <Navigate to="/login" replace />
        }
      />
    </Routes>
  );
}

export default App;


